const isValidDate = (date: any): date is Date => date instanceof Date && !isNaN(date.getTime());
export default isValidDate;
